__turbopack_context__.v({
  "item": "KWuP1G_item",
  "moreBtn": "KWuP1G_moreBtn",
  "moreWrap": "KWuP1G_moreWrap",
  "nav": "KWuP1G_nav",
  "navBtn": "KWuP1G_navBtn",
  "navBtnLeft": "KWuP1G_navBtnLeft",
  "navBtnRight": "KWuP1G_navBtnRight",
  "rail": "KWuP1G_rail",
  "railCapped": "KWuP1G_railCapped",
  "viewport": "KWuP1G_viewport",
});
